const Noticrud = () => {
  return <div>Noticrud</div>;
};

export default Noticrud;
